export function inittimeline(){
    if(document.querySelector('.cctimeline')){
        function isElementPartiallyInViewport(el) {
            const rect = el.getBoundingClientRect();
            return (
                rect.top < window.innerHeight && rect.bottom >= 0 &&
                rect.left < window.innerWidth && rect.right >= 0
            );
        }

        function elementsOverlap(el1, el2) {
            if (el1 instanceof jQuery) {
                el1 = el1[0];
            }
            if (el2 instanceof jQuery) {
                el2 = el2[0];
            }
            const domRect1 = el1.getBoundingClientRect();
            const domRect2 = el2.getBoundingClientRect();
            return !(
                domRect1.top > domRect2.bottom ||
                domRect1.right < domRect2.left ||
                domRect1.bottom < domRect2.top ||
                domRect1.left > domRect2.right
            );
        }

        let timelineSequence = [];

        //Place points on timeline corresponding to respective dates
        $('.cctimeline').each(function () {
            let [startDate, endDate] = [$(this).data('start'), $(this).data('end') + 2];

            let timeSpan = endDate - startDate;

            $(this).find('.ray__vert').each(function () {
                let year = $(this).data('time');
                let point = year - startDate;
                let timelinePoint = point / timeSpan;
                let percent = timelinePoint * 100;
                $(this).css('left', percent.toFixed(2) + '%');

                let timelineEntry = [this, { opacity: [null, 1] }, { at: Math.max(timelinePoint/* - 0.25*/, 0), duration: 0.1 }];
                //timelineSequence.push(timelineEntry);
                // console.log('timeline entry: ', timelineEntry);
            });
        });

        //fix overlaps
        let topsAndBottoms = $('.cctimeline .ray__vert--top').toArray()
            .concat($('.cctimeline .ray__vert--bottom').toArray());
        let overlapFound = true;
        let count = 0;

        while (overlapFound && count < 15) {
            // console.log('ROUND ', count);
            overlapFound = false;
            for (let x = 0; x < topsAndBottoms.length - 1; x++) {
                let curr = {
                    main: $(topsAndBottoms[x]),
                    time: $(topsAndBottoms[x]).find('.ray__vert__time'),
                    text: $(topsAndBottoms[x]).find('.ray__vert__text'),
                };
                let next = {
                    main: $(topsAndBottoms[x + 1]),
                    time: $(topsAndBottoms[x + 1]).find('.ray__vert__time'),
                    text: $(topsAndBottoms[x + 1]).find('.ray__vert__text'),
                };
                if(elementsOverlap(curr.text, next.time)){
                    overlapFound = true;
                    if (curr.main.hasClass('ray__vert--top')) {
                        curr.text[0].style.top = parseInt(getComputedStyle(curr.text[0]).top) + 10 + 'px';
                    } else {
                        curr.text[0].style.bottom = parseInt(getComputedStyle(curr.text[0]).bottom) + 10 + 'px';
                    }
                }
                if (elementsOverlap(curr.text, next.text)) {
                    overlapFound = true;
                    // console.log(curr.text.text().trim(), ' overlapping');
                    if (next.main.hasClass('ray__vert--top')) {
                        next.text[0].style.top = parseInt(getComputedStyle(next.text[0]).top) + 10 + 'px';
                    } else {
                        next.text[0].style.bottom = parseInt(getComputedStyle(next.text[0]).bottom) + 10 + 'px';
                    }
                }
            }

            count++;
        }

        // timelineSequence.unshift([document.querySelector('.cctimeline .ray__hor__animation'), { width: ['0', '2400px']} , { easing: 'linear' }]);
        // timelineSequence = [[document.querySelector('.cctimeline .ray__hor__animation'), { width: ['0', '2400px']} , { easing: 'linear' }]];

        let device = '';

        if(window.innerWidth >= 1024){
            device = 'desktop';
        }
        else if(window.innerWidth >= 768){
            device = 'tablet';
        }
        else{
            device = 'mobile';
        }


        let mainSequence = [[document.querySelector('.cctimeline .ray__hor__animation'), { width: ['150px', '2800px']} , { easing: 'linear'/*[.05,.51,.83,.67]*/ }]];


        Motion.inView('.cctimeline .ray__vert', function(e){
            // console.log('inView: ', e.target);
            Motion.animate(e.target.querySelector('.ray__vert__text'), { opacity: 1, }, { duration: 1 });
            Motion.animate(e.target.querySelectorAll('.ray__icon'), {
                opacity: 1,
                bottom: e.target.classList.contains('ray__vert--top') ? 'calc(100% + 1em)' : 'auto',
                top: e.target.classList.contains('ray__vert--bottom') ? 'calc(100% + 1em)' : 'auto',


            }, {
                duration: 1
            });

            Motion.animate(e.target, { opacity: 1 });
            return () => {
                // console.log('outView: ', e.target);
                Motion.animate(e.target.querySelector('.ray__vert__text'), { opacity: 0}, { duration: 1.5 });
                Motion.animate(e.target.querySelectorAll('.ray__icon'), {
                    opacity: 0.3,
                    bottom: e.target.classList.contains('ray__vert--top') ? 'calc(100% + 3em)' : 'auto',
                    top: e.target.classList.contains('ray__vert--bottom') ? 'calc(100% + 3em)' : 'auto',
                    duration: 1

                }, {
                    duration: 1
                });

                Motion.animate(e.target, { opacity: 0.3 });
            };

        }, {
            root: document.querySelector('.timeline'),
            margin: device === 'desktop' ? '0px -150px 0px -150px' : '0px -100px 0px -100px'
        });

        Motion.scroll(
            Motion.timeline(mainSequence),
            { container: document.querySelector(".timeline__wrapper"),
                axis: 'x'}
        );

        Motion.scroll(
            Motion.timeline(
                [[document.querySelector('.cctimeline .scrollicon'), { opacity: [1,0,0,0,0,0,0,0]}, { easing: 'linear' }]]
            ),
            { container: document.querySelector(".timeline__wrapper"),
                axis: 'x'}
        )

        Motion.scroll(
            Motion.timeline(
                [[document.querySelector('.cctimeline .cctimeline__arrow--left'), { opacity: [0.1,1,1,1,1,1,1,1]}, { easing: 'linear' }]]
            ),
            { container: document.querySelector(".timeline__wrapper"),
                axis: 'x'}
        )
        Motion.scroll(
            Motion.timeline(
                [[document.querySelector('.cctimeline .cctimeline__arrow--right'), { opacity: [1,1,1,1,1,1,1,0.1]}, { easing: 'linear' }]]
            ),
            { container: document.querySelector(".timeline__wrapper"),
                axis: 'x'}
        )

        Motion.scroll(
            Motion.timeline(
                [[document.querySelector('.cctimeline .cctimeline__nav__bar'), { left: ['0%', 'calc(100% - 50px)']}, { easing: 'linear'}]]
            ),
            { container: document.querySelector(".timeline__wrapper"),
                axis: 'x'}
        )

        $('.timeline .timeline__wrapper').each(function(){
            /*let current = $(this).find('.ray__vert').eq(0);
            const step = (direction) => {
                let wrapperScrollOffsetX = this.scrollLeft;
                let target = direction === 'left' ? $(this).prev('.ray') : $(this).next('.ray');
                if(target.length){
                // TODO: get next rays x offset and and update wrappers offset accordingly
                }
            }*/
            /*$(this).on('touchstart', function(e) {

                var touchStart = e.originalEvent.touches[0].clientX || e.originalEvent.changedTouches[0].clientX;
                var touchDistance = 0;
                var startOffset = e.currentTarget.scrollLeft;


                function touchMove(e) {
                    touchDistance = touchStart - e.originalEvent.touches[0].clientX ;
                    //console.log('touchDistance: ', touchDistance);
                    e.currentTarget.scrollLeft = startOffset + touchDistance;
                }
                $(this).on('touchmove', touchMove).one('touchend', function() {
                    $(this).off('touchmove', touchMove);
                });
            });*/
            $(this).on('wheel', function(e){
                e.preventDefault();
                /*e.currentTarget.scrollTo({
                    top:0,
                    left:e.currentTarget.scrollLeft + e.originalEvent.deltaY,
                    behaviour: 'smooth'
                });*/
                e.currentTarget.scrollLeft += e.originalEvent.deltaY;
            });
        });


        $('.cctimeline__arrow').on('click',function(){
            let wrapper = $(this).parents('.timeline__wrapper');
            let wrapperWidth = wrapper.width() * 0.5;
            //console.log('wrapperWidth: ', wrapperWidth);
            let currentScroll = wrapper.scrollLeft();
            if($(this).hasClass('cctimeline__arrow--left')){
                wrapper[0].scrollTo({
                    top:0,
                    left: currentScroll - wrapperWidth,
                    behavior: 'smooth'
                });
            }
            else{
                wrapper[0].scrollTo({
                    top:0,
                    left: currentScroll + wrapperWidth,
                    behavior: 'smooth'
                });
            }
        });

        $('.cctimeline__nav__bar').on('mousedown touchstart', function(e){
            e.preventDefault();
            e.stopPropagation();
            let container = $(this).parents('.cctimeline__nav')[0];
            let containerStyle = window.getComputedStyle(container);
            let barStyle = window.getComputedStyle(this);

            let total = parseFloat(containerStyle.width) - parseFloat(barStyle.width);
            let now = parseFloat(barStyle.left);
            let nowPercent = now / total * 100;

            let startX = e.originalEvent.clientX || e.originalEvent.changedTouches[0].clientX;

            let wrapper = $(this).parents('.timeline__wrapper')[0];
            let scrollableArea = wrapper.scrollWidth - wrapper.clientWidth;
            let scrollablePercent = scrollableArea / 100;

            this.style.height = '5000px';
            this.classList.add('cctimeline__nav__bar__active');

            //console.log('scrollablePercent: ', scrollablePercent);

            console.log('start');
            const onDrag = (e) => {
                e.stopPropagation();
                let offset = (e.clientX || e.changedTouches[0].clientX) - startX;
                let newPercent = Math.min(100,Math.max(0,(now + offset) / total * 100));
                //onsole.log('newPercent: ', newPercent);
                wrapper.scrollLeft =+ newPercent * scrollablePercent;
            }
            const cleanup = () => {
                this.style.height = null;
                this.classList.remove('cctimeline__nav__bar__active');

                window.removeEventListener('mouseup', cleanup);
                window.removeEventListener('touchend', cleanup);

                wrapper.removeEventListener('mouseleave', cleanup);
                wrapper.removeEventListener('touchend', cleanup);

                window.removeEventListener('mousemove', onDrag);
                window.removeEventListener('touchmove', onDrag);


                console.log('cleanup');

            };

            window.addEventListener('mousemove', onDrag, { passive: true});
            window.addEventListener('touchmove', onDrag, { passive: true});

            window.addEventListener('mouseup', cleanup, { passive: true});
            window.addEventListener('touchend', cleanup, { passive: true});

            wrapper.addEventListener('mouseleave', cleanup, { passive: true});
            wrapper.addEventListener('touchend', cleanup, { passive: true});


        });
    }
}

